import React from 'react';
import { ProtectedLayout } from '../components/layout/ProtectedLayout';
import { KarmaPanel } from '../components/karma/KarmaPanel';
import { ChecklistPanel } from '../components/checklist/ChecklistPanel';

const Welcome: React.FC = () => {
  const getGreeting = () => {
    const hour = new Date().getHours();
    if (hour < 12) return 'Good morning';
    if (hour < 18) return 'Good afternoon';
    return 'Good evening';
  };

  return (
    <ProtectedLayout>
      {({ user }) => {
        const greeting = getGreeting();
        const isAdmin = user.is_staff || user.username.toLowerCase() === 'admin';
        const canManage = isAdmin;
        return (
          <div className="space-y-10">
            <header className="rounded-xl border border-border bg-card p-6 shadow-sm">
              <h1 className="text-3xl font-semibold tracking-tight text-foreground sm:text-4xl">
                {greeting}, {user.username}!
              </h1>
              <p className="mt-2 text-base text-muted-foreground">
                Welcome back to Kitten Connect. Keep tabs on progress and stay on track.
              </p>
            </header>
            <section className="space-y-4">
              <div className="flex items-center justify-between">
                <h2 className="text-xl font-semibold text-foreground">Karma Status</h2>
              </div>
              <KarmaPanel isAdmin={isAdmin} />
            </section>
            <section className="space-y-4">
              <div className="flex items-center justify-between">
                <h2 className="text-xl font-semibold text-foreground">Checklist</h2>
              </div>
              <ChecklistPanel canManage={canManage} />
            </section>
          </div>
        );
      }}
    </ProtectedLayout>
  );
};

export default Welcome;
